<template>
    <section id="advanced-search">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-3 col-4">
                    <SearchFilter 
                        @changeFilters="filters = $event"/>
                </div>
                <div class="col-lg-9 col-8">
                    <Filters 
                        :filters="filters"/>
                    <SearchResult/>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import SearchFilter from './SearchFilter.vue'
import Filters from './Filters'
import SearchResult from './SearchResult'

export default {
    name: "AdvancedSearch",
    components: {
        Filters,
        SearchFilter,
        SearchResult,
    },
    data() {
        return {
            filters: {}
        }
    },
    mounted: function() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    methods: {
        onChange: function (e) {
            console.log(e)
        }
    }
}
</script>